import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'

export const fetchApartments = createAsyncThunk('apartments/fetchAll', async (_, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartments`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartments: Object.values(response.data) }
})

export const fetchApartment = createAsyncThunk('apartment/fetch', async ({ id }, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartment/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartment: response.data.apartment }
})

export const updateApartment = createAsyncThunk('apartment/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartment/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartment: response.data.apartment }
})

export const createApartmentMember = createAsyncThunk('apartment_member/create', async ({ type, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartment_${type}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartment: response.data.apartment }
})

export const updateApartmentMember = createAsyncThunk('apartment_member/update', async ({ id, type, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartment_${type}/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartment: response.data.apartment }
})

export const deleteApartmentMember = createAsyncThunk('apartment_member/delete', async ({ id, type }, { rejectWithValue }) => {
    const response = await ApiService.delete(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/apartment_${type}/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { apartment: response.data.apartment }
})

const initialState = {
    apartments: [],
    selectedApartment: null,
    loading: false,
    submitting: false,
    error: null
}

const apartmentSlice = createSlice({
    name: 'apartments',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchApartments.pending]: (state) => {
            state.loading = true
        },
        [fetchApartments.fulfilled]: (state, { payload }) => {
            state.apartments = payload.apartments
            state.loading = false
        },
        [fetchApartments.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchApartment.pending]: (state) => {
            state.loading = true
        },
        [fetchApartment.fulfilled]: (state, { payload }) => {
            state.selectedApartment = payload.apartment
            state.loading = false
        },
        [fetchApartment.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateApartment.pending]: (state) => {
            state.submitting = true
        },
        [updateApartment.fulfilled]: (state, { payload }) => {
            state.selectedApartment = payload.apartment
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateApartment.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        },

        [createApartmentMember.pending]: (state) => {
            state.submitting = true
        },
        [createApartmentMember.fulfilled]: (state, { payload }) => {
            state.selectedApartment = payload.apartment
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [createApartmentMember.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        },

        [updateApartmentMember.pending]: (state) => {
            state.submitting = true
        },
        [updateApartmentMember.fulfilled]: (state, { payload }) => {
            state.selectedApartment = payload.apartment
            state.submitting = false

            ToastCtl.success('Daten wurden erfolgreich gespeichert')
        },
        [updateApartmentMember.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Daten konnten nicht gespeichert werden')
        },

        [deleteApartmentMember.pending]: (state) => {
            state.submitting = true
        },
        [deleteApartmentMember.fulfilled]: (state, { payload }) => {
            state.selectedApartment = payload.apartment
            state.submitting = false

            ToastCtl.success('Zuordnung wurde gelöscht')
        },
        [deleteApartmentMember.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly

            ToastCtl.error('Zuordnung konnte nicht gelöscht werden')
        }
    }
})

export default apartmentSlice.reducer